import { useRef, useState } from 'react';
import styles from '../../styles/home/home.module.css';
import { getMsisdnInfo } from '../../ApiCalls/Home/api_v1_home';

function MsisdnForm({ msisdnRef, updateDetails, setDetailsLoading, setShowError, setErrorMsg }) {
    const btnSubmitRef = useRef(null);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isChecked, setIsChecked] = useState(false);

    const handleCheckboxChange = (event) => {
        setIsChecked(event.target.checked);
    };
    const handleSubmit = (event) => {
        event.preventDefault();
        if (msisdnRef.current.value === "") {
            return;
        }
        setIsDisabled(true);
        setDetailsLoading(true);
        setShowError(false);
        const msisdn = msisdnRef.current.value;

        let formdata = {
            "msisdn": msisdn,
        }

        getMsisdnInfo(formdata).then((res) => {
            setIsDisabled(false);
            setDetailsLoading(false);

            let ufd = res.data.ufd.details;
            let esg = res.data.esg.details;
            if (res.status === 200 && res.data.message === "ok") {

                let details = [
                    {
                        msisdn: msisdn,
                        status: ufd.current_status,
                        action: ufd.action,
                        service: "UFONE DING"
                    },
                    {
                        msisdn: msisdn,
                        status: esg.current_status,
                        action: esg.action,
                        service: "ESPORTSGAMING"
                    }
                ];
                updateDetails(details);
            } else {
                setIsDisabled(false);
                setErrorMsg("MSISDN NOT FOUND");
                setShowError(true);
                setDetailsLoading(null);

            }

        }).catch((e) => {
            setIsDisabled(false);
            setErrorMsg("We can not process your request at this time please try later");
            setShowError(true);
            setDetailsLoading(null);

        })
    }



    return (
        <form onSubmit={handleSubmit} className='text-center mt-3 d-flex flex-column justify-content-center align-items-center' style={{ minHeight: "136px" }}>
            <input type="text" className={styles.form_input} placeholder="03xxxxxxxxx" name="phone" required="True" minLength="11" maxLength="11" id="field" autoComplete="off" ref={msisdnRef} onInput={(e) => {
                e.target.value = e.target.value.replace(/[^0-9]/g, "");
            }}></input>
            <button className={styles.otpButton + '  btn mt-15 mb-15 '} id="btnsubmit" type='submit' disabled={isDisabled} ref={btnSubmitRef}>
                Submit
            </button>
        </form>
    )
}

export default MsisdnForm;